// 对图片操作
import { Message } from 'element-ui'

function combineImageByUrl(urls, positionList, isHorizontalImage, callback) {
	let imgs = []
	let canvasImg = {}
	Promise.resolve().then(() => {
		urls.map(v => v.toString()).map(function(v, i) {
			let img = new Image()
			img.setAttribute('crossOrigin', '*')
			img.src = v
			img.crossOrigin = 'Anonymous'
			img.onload = function() {
				imgs.push([img, i])
				if (urls.length === imgs.length) {
					imgs.sort((s1, s2) => s1[1] - s2[1])
					if (isHorizontalImage) {
						canvasImg = horizontalJoinImg(
							imgs.map(v => v[0]),
							positionList
						)
					} else {
						canvasImg = verticalJoinImg(
							imgs.map(v => v[0]),
							positionList
						)
					}
				}
				callback && callback(canvasImg)
			}
			img.onerror = function() {
				Message.error('考生答题卡图片加载异常，请联系管理员！')
				callback && callback({ img: '' })
			}
		})
	})
	// 竖直拼接图片
	function verticalJoinImg(imgs, positionList) {
		let canvas = document.createElement('canvas')
		let ctx = canvas.getContext('2d')
		const width = Math.max(...imgs.map(v => v.width))
		const height = imgs.map(v => v.height).reduce((acc, cur) => (acc += cur), 0)
		canvas.width = width
		canvas.height = height
		let count_h = 0
		imgs.forEach(function(v) {
			ctx.drawImage(v, 0, count_h)
			count_h += v.height + 10
		})
		if (positionList.length) {
			positionList.forEach(res => {
				ctx.fillStyle = '#fe0101'
				ctx.font = 'bolder 80px STSong'
				ctx.fillText(res[2], res[0] - 20, res[1] + 20)
			})
		}
		return {
			img: canvas.toDataURL('image/png'),
			width,
			height: count_h
		}
	}
	//水平拼接图片
	function horizontalJoinImg(imgs, positionList) {
		let canvas = document.createElement('canvas')
		let ctx = canvas.getContext('2d')
		const height = Math.max(...imgs.map(v => v.height))
		const width = imgs.map(v => v.width).reduce((acc, cur) => (acc += cur), 0)
		canvas.height = height
		canvas.width = width
		let count_w = 0
		imgs.forEach(function(v) {
			ctx.drawImage(v, count_w, 0)
			count_w += v.width + 10
		})
		if (positionList.length > 0) {
			positionList.forEach(res => {
				ctx.fillStyle = '#fe0101'
				ctx.font = 'bolder 50px Arial'
				ctx.fillText(res[2], res[0] - 20, res[1] + 20)
			})
		}
		// return canvas.toDataURL('image/png')
		return {
			img: canvas.toDataURL('image/png'),
			width,
			height
		}
	}
}

export { combineImageByUrl }
